














































































import {Component, Vue}         from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import {TabEnum}                from "@/util/enums/TabEnum";

@Component({
    computed  : {
        ...mapGetters({
            displaySidebar   : 'displaySidebar',
            currentTab       : 'currentTab',
            batchIsSelected  : 'batchIsSelected',
            projectIsSelected: 'projectIsSelected'
        }),
    },
    methods   : {
        ...mapActions({
            changeTab: 'changeTab',
        }),
    },
    components: {
        'SearchBar'            : () => import("@/components/Tabs/SearchBar.vue"),
        'NeighborBatches'      : () => import("@/components/Tabs/NeighborBatches.vue"),
        'BatchInfrastructure'  : () => import("@/components/Tabs/BatchInfrastructure.vue"),
        'ProjectInfrastructure': () => import("@/components/Tabs/ProjectInfrastructure.vue"),
        'Drawing'              : () => import("@/components/Tabs/Drawing.vue"),
        'Layers'               : () => import("@/components/Tabs/Layers.vue"),
        'Favorite'             : () => import("@/components/Tabs/Favorite.vue"),
        'Print'                : () => import("@/components/Tabs/Print.vue"),
        'Info'                 : () => import("@/components/Tabs/Info.vue"),
    }
})
export default class Sidebar extends Vue {
    private tabs: typeof TabEnum;

    constructor() {
        super();
        this.tabs = TabEnum;
    }

}

